import React from 'react';
import "./CourierShipmentSuccessModal.css"
import { Link } from 'react-router-dom';



const CourierShipmentSuccess = ({ data }) => {
  const { message, shipment_id, rates } = data;

  // Find the cheapest price
  const minPrice = Math.min(...rates.map((r) => r.price));

  return (
    <div className="max-w-3xl mx-auto px-1 py-8">
      {/* Success Message */}
      <div className="bg-green-100 border border-green-300 text-green-800 rounded-md p-4 mb-6 shadow-sm">
        <h2 className="text-lg font-semibold mb-1"> { (rates && rates.length > 0 ? "🔔" : "✅")} {message}</h2>
        <p className="text-sm text-green-700">Shipment ID: {shipment_id}</p>
      </div>

     {rates && rates.length > 0 && (
      <div className="responsive-table" style={{ overflowX: "auto", width: "100%" }}>
        <table className="rates-table" style={{ minWidth: "700px", width: "100%" }}>
          <thead className="bg-gray-100 text-gray-600 uppercase text-xs">
            <tr>
              <th className="px-4 py-3">Service Provider</th>
              <th className="px-4 py-3">Service Name</th>
              <th className="px-4 py-3">Delivery Date</th>
              <th className="px-4 py-3">Pickup Date</th>
              <th className="px-4 py-3">Transit Days</th>
              <th className="px-4 py-3">Price</th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {rates?.map((rate, idx) => {
              const isCheapest = rate.price === minPrice;

              return (
                <tr
                  key={idx}
                  className={`border-t ${isCheapest ? 'bg-yellow-50' : 'hover:bg-gray-50'}`}
                >
                  <td className="px-4 py-3 font-medium">{rate.service_provider}</td>
                  <td className="px-4 py-3">{rate.service_name}</td>
                  <td className="px-4 py-3">{rate.delivery_date}</td>
                  <td className="px-4 py-3">{rate.pickup_date}</td>
                  <td className="px-4 py-3">{rate.transit_days}</td>
                  <td className="px-4 py-3 font-semibold">{rate.price}</td>
                  <td className="px-4 py-3">
                    <Link className="view-btn btn-generic" to={rate.link}  target="_blank"
  rel="noopener noreferrer">
                        Choose
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      )}
    </div> 
    
  );
};

export default CourierShipmentSuccess;
